import { STATES } from "~/utilities/constants"

const PLATE_VALIDATIONS = {
  plateNumber: value => {
    if (!value.match(/^\w{3,10}$/)) {
      return 'Plate must be 3 to 10 alphanumeric characters.'
    }
    return false
  },
  state: value => {
    if (!value || !STATES[value]) return 'Please select a state.'
    return false
  }
}

export default PLATE_VALIDATIONS
